import { render, staticRenderFns } from "./StockListItem.vue?vue&type=template&id=0f7e671e&scoped=true"
import script from "./StockListItem.vue?vue&type=script&lang=js"
export * from "./StockListItem.vue?vue&type=script&lang=js"
import style0 from "./StockListItem.vue?vue&type=style&index=0&id=0f7e671e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@6.26.3_cache-loader@4.1.0_webpac_ddacfd63a0804571a953918ce6bcb0d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e671e",
  null
  
)

export default component.exports